<div class="display-flex flex-column grid-gap-8">
  <div class="display-flex flex-column grid-gap-4">
    <div class="display-flex align-items-center justify-content-space-between question-item">
      <div class="display-flex align-items-center grid-gap-4">
        <div class="display-flex align-items-center grid-gap-4">
          <div
            class="display-flex align-items-center grid-gap-8"
            [ngStyle]="{ cursor: !this.fileSectionExpanded || file?.visible === false ? 'pointer' : 'default' }"
            [matTooltip]="file?.visible === false ? 'Restore ' + selectedFileOptionLabel : undefined"
            (click)="expandSetting('file')">
            <div
              class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field"
              [ngClass]="{ 'thumb-icon-removed': file?.visible === false }">
              <app-icon
                [svg]="EIcon.REQUIRE_PHOTO"
                [iconWidth]="18"
                [iconHeight]="18"
                [iconColor]="EColorPalette.cGreen"></app-icon>
            </div>
            <span [ngClass]="{ 'setting-line-through': file?.visible === false }">
              Add {{ selectedFileOptionLabel }}
            </span>
          </div>
        </div>

        <div class="actions">
          <button
            aria-label="delete-button"
            type="button"
            class="action-button"
            mat-icon-button
            [matTooltip]="file?.visible === false ? 'Restore photos & documents' : 'Remove photos & documents'"
            matTooltipShowDelay="500"
            (click)="toggleRemove('file')">
            <app-icon
              [iconWidth]="16"
              [iconHeight]="16"
              [svg]="file?.visible === false ? EIcon.RESTORE_FROM_TRASH : EIcon.MAT_DELETE_FOREVER"></app-icon>
          </button>
        </div>
      </div>

      <button
        *ngIf="file?.visible !== false"
        aria-label="toggle-button"
        class="toggle-button"
        type="button"
        mat-icon-button
        [matTooltip]="fileSectionExpanded ? 'Collapse settings' : 'Expand settings'"
        (click)="toggleSetting('file')">
        <app-icon
          [svg]="fileSectionExpanded ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
          [iconWidth]="8"
          [iconHeight]="8"
          [iconColor]="EColorPalette.cGray5"></app-icon>
      </button>
    </div>

    <div *ngIf="fileSectionExpanded" class="optional-content-container optional-content-container-constants">
      <div class="display-flex flex-column grid-gap-4">
        <ng-container *ngIf="form" [formGroup]="form">
          <app-radio-button
            formControlName="fileOption"
            [items]="fileOptions"
            [radioGroupClass]="'display-flex flex-column'"
            [optionCss]="'body'"></app-radio-button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="display-flex align-items-center grid-gap-4 question-item">
    <div class="display-flex align-items-center grid-gap-4">
      <div
        class="display-flex align-items-center grid-gap-8"
        [ngStyle]="{ cursor: comment?.visible === false ? 'pointer' : 'default' }"
        [matTooltip]="comment?.visible === false ? 'Restore comments' : undefined"
        (click)="comment?.visible === false ? toggleRemove('comment') : undefined">
        <div
          class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field"
          [ngClass]="{ 'thumb-icon-removed': comment?.visible === false }">
          <app-icon
            [svg]="EIcon.COMMENT3"
            [iconWidth]="18"
            [iconHeight]="18"
            [iconColor]="EColorPalette.cGreen"></app-icon>
        </div>
        <span [ngClass]="{ 'setting-line-through': comment?.visible === false }">Add comments</span>
      </div>
    </div>

    <div class="actions">
      <button
        aria-label="delete-button"
        type="button"
        class="action-button"
        mat-icon-button
        [matTooltip]="comment?.visible === false ? 'Restore comments' : 'Remove comments'"
        matTooltipShowDelay="500"
        (click)="toggleRemove('comment')">
        <app-icon
          [iconWidth]="16"
          [iconHeight]="16"
          [svg]="comment?.visible === false ? EIcon.RESTORE_FROM_TRASH : EIcon.MAT_DELETE_FOREVER"></app-icon>
      </button>
    </div>
  </div>
</div>
